import { render, staticRenderFns } from "./ChroniclesNights.vue?vue&type=template&id=1ae9c69a&scoped=true"
import script from "./ChroniclesNights.vue?vue&type=script&lang=js"
export * from "./ChroniclesNights.vue?vue&type=script&lang=js"
import style0 from "./ChroniclesNights.vue?vue&type=style&index=0&id=1ae9c69a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9c69a",
  null
  
)

export default component.exports